// Parish-branded volunteer front door at /:parish/welcome.
//
// This is where a parish's invite email sends its volunteers — NOT
// the root marketing page, which is coordinator-facing and talks
// pricing. This page wears the parish's own brand (like the help
// center) and offers exactly three doors: create an account, sign
// in, read the help center. No product marketing, no pricing, no
// Sacristy sales voice — a volunteer arriving here was invited by
// their parish and should feel that.
//
// Deliberately a sub-path, not a bare /:parish route: a single
// dynamic segment would swallow every admin URL (/settings,
// /shortlist, …) that the catch-all serves today.

import { Link, useParams } from "react-router-dom";
import { useParish } from "../lib/parishContext";
import ParishLogo from "../components/ParishLogo";
import PoweredByFooter from "../components/PoweredByFooter";

export default function VolunteerWelcome() {
  const { parish: slug } = useParams();
  const { parish, loading } = useParish();

  return (
    <main className="page vwelcome">
      <div className="vwelcome__card">
        <div className="vwelcome__brand">
          <ParishLogo size={96} showName={false} />
        </div>
        <p className="vwelcome__eyebrow">{loading ? " " : parish.display_name}</p>
        {/* Same welcome line as the help center — one established
            voice for volunteers across every surface. */}
        <h1 className="vwelcome__title">Welcome — and thank you for saying yes.</h1>
        <p className="vwelcome__lede">
          Your Mass schedule, online. See when you serve and request subs, all in one place.
        </p>
        <div className="vwelcome__actions">
          <Link className="btn vwelcome__cta" to={`/${slug}/signup`}>
            Create your account
          </Link>
          <Link className="btn btn--ghost" to={`/${slug}/login`}>
            Sign in
          </Link>
        </div>
        <p className="vwelcome__help">
          Questions?{" "}
          <Link className="sign-in__link" to={`/${slug}/help`}>
            The help center
          </Link>{" "}
          covers everything.
        </p>
      </div>
      <PoweredByFooter />
    </main>
  );
}
